<script setup lang="ts" generic="T extends Record<string, any> | undefined = undefined">
import TopPopup from '@/components/popup/popup/popup.vue';
import TopHint from '@/components/forms/hint/hint.vue';
import type { Props } from './types';

const props = defineProps<Props<T>>();

const {
	hint,
	...propsPopup
}: Props<T> = props;
</script>

<template>
	<!-- @vue-generic {T} -->
	<TopPopup
		class="top-popupHint"
		:=propsPopup
		@open="$emit('open', $event)"
		@close="$emit('close', $event)"
		@scrollContentList="(...args) => $emit('scrollContentList', ...args)"
	>
		<template #opener>
			<!-- Элемент для открытия Popup -->
			<TopHint
				:hint="hint"
				class="top-popupHint_opener"
				v-top-tooltip
			/>
		</template>

		<template #content v-if="$slots.default">
			<!-- @slot Контент в свободной форме -->
			<slot></slot>
		</template>
	</TopPopup>
</template>

<style>
.top-popupHint_opener {
	cursor: pointer;
}

.top-popupHint_opener.top-active {
	color: var(--color-text-2);
}
</style>
